import { Copy06 } from '@ethsign/icons';
import { toast } from '@ethsign/ui';
import { useEffect } from 'react';
import { useCopyToClipboard } from 'react-use';

type Props = {
  text?: string;
  displayText?: string | React.ReactNode;
  buttonSize?: number;
  className?: string;
  render?: (props: { copy: () => void }) => React.ReactNode;
  iconPosition?: 'left' | 'right' | 'none';
};
export function CopyText(props: Props) {
  const [state, copyToClipboard] = useCopyToClipboard();
  const { displayText, text, buttonSize, className, render, iconPosition = 'right' } = props;

  useEffect(() => {
    if (!state.value || !text) return;
    if (state.error) {
      toast({
        title: 'Copy failed',
        description: state.error.message,
        variant: 'error'
      });
    } else {
      toast({
        title: 'Copy success',
        description: <span className="break-all">{`Copied ${text}`}</span>,
        variant: 'success'
      });
    }
  }, [state]);

  if (render) {
    return render({ copy: () => copyToClipboard(text || '') });
  }
  return (
    <span
      className={`flex flex-row items-center cursor-pointer ${className || ''}`}
      onClick={() => {
        copyToClipboard(text || '');
      }}
    >
      {iconPosition === 'left' && <Copy06 size={buttonSize || 20} color={'#667085'} className={'inline-block mr-2'} />}
      {displayText}
      {iconPosition === 'right' && <Copy06 size={buttonSize || 20} color={'#667085'} className={'inline-block ml-2'} />}
    </span>
  );
}
